/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import {CRISPRAnalysis} from 'constants/CRISPRConstants';
import CRISPRAssemblyActions from 'molbio/crispr/assembly/CRISPRAssemblyActions';
import * as navigation from 'Navigation';
import uniqueId from 'util/uniqueId';

interface CRISPRAssemblyTabStateAttributes extends navigation.TabStateDefaults {
  assemblyCid: string;
  sequenceName: string;
  basesList: Array<string>;
  analysis: CRISPRAnalysis;
}

interface CRISPRAssemblyTabState {
  get<K extends keyof CRISPRAssemblyTabStateAttributes>(key: K): CRISPRAssemblyTabStateAttributes[K];
  set<K extends keyof CRISPRAssemblyTabStateAttributes>(
    attributeName: K,
    value: CRISPRAssemblyTabStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): this;
  set(obj: Partial<CRISPRAssemblyTabStateAttributes>): this;
}

class CRISPRAssemblyTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.defaults(), {
      title: 'Assemble CRISPR',
      closeable: true,
    });
  }

  override initialize(): void {
    this.set('assemblyCid', uniqueId('crispr-assembly-'));
    CRISPRAssemblyActions.getAllVectors();
    CRISPRAssemblyActions.createAssembly(
      this.assemblyCid(),
      this.get('analysis'),
      Array.from(this.get('basesList')).map((bases, i) => ({
        name: `${this.sequenceName()} Assembly ${i + 1}`,
        bases,
      }))
    );
  }

  assemblyCid(): string {
    return this.get('assemblyCid');
  }
  sequenceName(): string {
    return this.get('sequenceName');
  }
}

export default CRISPRAssemblyTabState;
